import React, { useState } from 'react';

export function FlipCard({
  front,
  back,
  height = 160,
  frontClassName = '',
  backClassName = '',
  frontStyle,
  backStyle,
  padded = true,
  onClick,
}) {
  const [flipped, setFlipped] = useState(false);

  const flip = (e) => {
    // Allow parent handlers to run first (e.g., analytics) then flip
    if (onClick) onClick(e, !flipped);
    setFlipped((f) => !f);
  };

  return (
    <div
      className={`flip-card ${flipped ? 'flipped' : ''}`}
      style={{ height }}
      onClick={flip}
      role="button"
      tabIndex={0}
      aria-pressed={flipped}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(e); } }}
    >
      <div className="flip-card-inner cursor-pointer">
        <div
          className={`flip-card-face flip-card-front ${padded ? '' : 'flip-card-face--no-pad'} ${frontClassName}`}
          style={frontStyle}
        >
          {front}
        </div>
        <div
          className={`flip-card-face flip-card-back ${padded ? '' : 'flip-card-face--no-pad'} ${backClassName}`}
          style={backStyle}
        >
          {back}
        </div>
      </div>
    </div>
  );
}
